import { GET_CREDITS } from "constants/credits";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CREDITS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
